
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/aep/recommendations",
      function () {
        return require("private-next-pages/account/aep/recommendations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/aep/recommendations"])
      });
    }
  